import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  objective: {
    read: ["all"],
    create: ["master", "executive", "program_manager"],
    update: ["master", "executive", "program_manager"],
    delete: ["master", "executive", "program_manager"],
    config: ["master", "executive", "program_manager"]
  },
  objective_target: {
    read: ["all"],
    create: ["master", "administrator", "executive", "program_manager"],
    update: ["master", "administrator", "executive", "program_manager"],
    delete: ["master", "administrator", "executive", "program_manager"],
    config: ["master", "administrator", "executive", "program_manager"]
  },
  objective_learning: {
    read: ["all"],
    create: ["master", "administrator", "executive", "program_manager"],
    update: ["master", "administrator", "executive", "program_manager"],
    delete: ["master", "administrator", "executive", "program_manager"],
    config: ["master", "administrator", "executive", "program_manager"]
  },
  strategic_decision: {
    read: ["all"],
    config: ["master", "executive"],
    create: ["master", "executive"],
    update: ["master", "executive"],
    delete: ["master", "executive"]
  }
};
